<template>
    <div class="show-more">
        <transition name='more'>
            <div v-show="isShowMore" class="others-condition">
                <slot name="more-condition-content"></slot>
            </div>
        </transition>
        <div class="more-condition bm bm-pc">
            <div class="more-left"></div>
            <div class="more-c-todo bm bm-pc" 
                :class="isShowMore?'is-show-more': 'no-showmore'"
                @click="showMoreCondition">
                <div class="more-down-i"></div>
            </div>
            <div class="more-right"></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isShowMore: false
        };
    },
    methods: {
        showMoreCondition() {
            this.isShowMore = !this.isShowMore;
            this.$emit('showMore', this.isShowMore);
        }
    }
}
</script>
<style lang="scss">
.show-more {
    width: 100%;
    position: relative;
    .others-condition {
        width: 100%;
        padding-top: 10px;
    }
    .more-enter-active {
        opacity: 1;
        transition: opacity 1s ease-out;
    }
    .more-leave-active {
        opacity: 0;
        transition: opacity .5s;
    }
    .more-enter {// 类名:初始化状态
        opacity: 0;
    }
    .more-condition {
        width: 100%;
        height: 10px;
        margin-top: 10px;
        background-color: #ffffff;
        // position: absolute;
        // bottom: 0;
        // left: 0;
        .no-showmore {
            .more-down-i {
                width: 0px;
                height: 0px;
                border-top:6px solid #ffffff;
                border-right:6px solid  rgba(0,0,0,0);
                border-bottom:6px solid rgba(0,0,0,0);
                border-left:6px solid  rgba(0,0,0,0);
                margin-top: 3px;
            }
        }
        .is-show-more {
            .more-down-i {
                width: 0px;
                height: 0px;
                border-top:6px solid rgba(0,0,0,0);
                border-right:6px solid  rgba(0,0,0,0);
                border-bottom:6px solid #ffffff;
                border-left:6px solid  rgba(0,0,0,0);
                margin-top: -3px;
            }
        }
        .more-c-todo {
            width: 100px;
            height: 10px;
            background-color: #f0f2f5;
            cursor: pointer;
        }
        .more-left,
        .more-right {
            width:0px;
            height:0px;
            border-top:10px solid rgba(0,0,0,0);
            border-right:10px solid  rgba(0,0,0,0);
            border-bottom:10px solid #f0f2f5;
            border-left:10px solid  rgba(0,0,0,0);
            margin-top: -20px;
        }
        .more-left {
            transform: translate(10px,10px);
        }
        .more-right {
            transform: translate(-10px,10px);
        }
    }
}
</style>


